var render = function render(_c, _vm) {
  return _c("article", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticStyle: { overflow: "scroll" } }, [
      _c("table", { staticClass: "roomy" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("tbody", [
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _vm._m(4),
          _vm._v(" "),
          _vm._m(5),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("CSS-only Kits")]),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("font-awesome-icon", {
                  staticStyle: { color: "var(--fa-teal)" },
                  attrs: {
                    icon: _vm.parent.$v7.solid.faCheckCircle,
                    size: "lg",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [_vm._v("Supported")]),
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(6),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("Icon Sizing")]),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("font-awesome-icon", {
                  staticStyle: { color: "var(--fa-teal)" },
                  attrs: {
                    icon: _vm.parent.$v7.solid.faCheckCircle,
                    size: "lg",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [_vm._v("Supported")]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("font-awesome-icon", {
                  staticStyle: { color: "var(--fa-teal)" },
                  attrs: {
                    icon: _vm.parent.$v7.solid.faCheckCircle,
                    size: "lg",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [_vm._v("Supported")]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("Icon Rotating")]),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("font-awesome-icon", {
                  staticStyle: { color: "var(--fa-teal)" },
                  attrs: {
                    icon: _vm.parent.$v7.solid.faCheckCircle,
                    size: "lg",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [_vm._v("Supported")]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("font-awesome-icon", {
                  staticStyle: { color: "var(--fa-teal)" },
                  attrs: {
                    icon: _vm.parent.$v7.solid.faCheckCircle,
                    size: "lg",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [_vm._v("Supported")]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v("Listed, Bordered, and Pulled Styling"),
            ]),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("font-awesome-icon", {
                  staticStyle: { color: "var(--fa-teal)" },
                  attrs: {
                    icon: _vm.parent.$v7.solid.faCheckCircle,
                    size: "lg",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [_vm._v("Supported")]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("font-awesome-icon", {
                  staticStyle: { color: "var(--fa-teal)" },
                  attrs: {
                    icon: _vm.parent.$v7.solid.faCheckCircle,
                    size: "lg",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [_vm._v("Supported")]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("Icon Animations")]),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("font-awesome-icon", {
                  staticStyle: { color: "var(--fa-teal)" },
                  attrs: {
                    icon: _vm.parent.$v7.solid.faCheckCircle,
                    size: "lg",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [_vm._v("Supported")]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("font-awesome-icon", {
                  staticStyle: { color: "var(--fa-teal)" },
                  attrs: {
                    icon: _vm.parent.$v7.solid.faCheckCircle,
                    size: "lg",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [_vm._v("Supported")]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("Stacking Icons")]),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("font-awesome-icon", {
                  staticStyle: { color: "var(--fa-teal)" },
                  attrs: {
                    icon: _vm.parent.$v7.solid.faCheckCircle,
                    size: "lg",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [_vm._v("Supported")]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("font-awesome-icon", {
                  staticStyle: { color: "var(--fa-teal)" },
                  attrs: {
                    icon: _vm.parent.$v7.solid.faCheckCircle,
                    size: "lg",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [_vm._v("Supported")]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("Power Transforms")]),
            _vm._v(" "),
            _vm._m(7),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("font-awesome-icon", {
                  staticStyle: { color: "var(--fa-teal)" },
                  attrs: {
                    icon: _vm.parent.$v7.solid.faCheckCircle,
                    size: "lg",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [_vm._v("Supported")]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("Masking")]),
            _vm._v(" "),
            _vm._m(8),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("font-awesome-icon", {
                  staticStyle: { color: "var(--fa-teal)" },
                  attrs: {
                    icon: _vm.parent.$v7.solid.faCheckCircle,
                    size: "lg",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [_vm._v("Supported")]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v("Layering Text and Counters"),
            ]),
            _vm._v(" "),
            _vm._m(9),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("font-awesome-icon", {
                  staticStyle: { color: "var(--fa-teal)" },
                  attrs: {
                    icon: _vm.parent.$v7.solid.faCheckCircle,
                    size: "lg",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [_vm._v("Supported")]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v("Auto-Accessibility"),
            ]),
            _vm._v(" "),
            _vm._m(10),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("font-awesome-icon", {
                  staticStyle: { color: "var(--fa-teal)" },
                  attrs: {
                    icon: _vm.parent.$v7.solid.faCheckCircle,
                    size: "lg",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [_vm._v("Supported")]),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function (_c, _vm) {
    return _c("p", { staticClass: "margin-bottom-2xl" }, [
      _vm._v(
        "\n    Font Awesome comes with two different web frameworks for easily using icons on the web: our original\n    "
      ),
      _c("strong", [_vm._v("Web Fonts & CSS")]),
      _vm._v("\n    method and our newer\n    "),
      _c("strong", [_vm._v("SVG & JS")]),
      _vm._v(
        "\n    framework. Each has benefits and caveats - pick the one that works best for your project and situation.\n  "
      ),
    ])
  },
  function (_c, _vm) {
    return _c("thead", [
      _c("tr", [
        _c("th", [
          _c("span", { staticClass: "sr-only" }, [_vm._v("Feature/Option")]),
        ]),
        _vm._v(" "),
        _c("th", [_vm._v("Web Fonts & CSS")]),
        _vm._v(" "),
        _c("th", [_vm._v("SVG & JS")]),
      ]),
    ])
  },
  function (_c, _vm) {
    return _c("tr", [
      _c("th", { attrs: { scope: "row" } }, [_vm._v("How Icons Render")]),
      _vm._v(" "),
      _c("td", [
        _vm._v(
          "\n            As CSS pseudo-elements and styled as the Font Awesome\n            "
        ),
        _c("code", { staticClass: "orange5" }, [_vm._v("font-family")]),
        _vm._v(".\n          "),
      ]),
      _vm._v(" "),
      _c("td", [_vm._v("As SVG elements in your page's HTML.")]),
    ])
  },
  function (_c, _vm) {
    return _c("tr", [
      _c("th", { attrs: { scope: "row" } }, [_vm._v("Best For")]),
      _vm._v(" "),
      _c("td", [
        _c("p", [
          _vm._v("People who are used to Font Awesome's older versions."),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("People who projects already using Font Awesome 4.X."),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "People using content management systems and site building tools like WordPress and Squarespace."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("td", [
        _c("p", [_vm._v("People who prefer to use SVGs to display icons.")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "People who don't mind rolling up their sleeves with Front End code."
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("People who want Auto-Accessibility enabled for their icons."),
        ]),
      ]),
    ])
  },
  function (_c, _vm) {
    return _c("tr", [
      _c("th", { attrs: { scope: "row" } }, [_vm._v("Upgrading Difficulty")]),
      _vm._v(" "),
      _c("td", [
        _vm._v("Similar file structure and framework. Shim available."),
      ]),
      _vm._v(" "),
      _c("td", [
        _vm._v(
          "Different files and references needed. Some rendering proofing is needed. Shim available."
        ),
      ]),
    ])
  },
  function (_c, _vm) {
    return _c("tr", [
      _c("th", { attrs: { scope: "row" } }, [_vm._v("Requirements")]),
      _vm._v(" "),
      _c("td", [
        _vm._v("CSS and a browser that supports web fonts (leveraging "),
        _c("code", { staticClass: "orange5" }, [_vm._v("@font-face")]),
        _vm._v(")."),
      ]),
      _vm._v(" "),
      _c("td", [
        _vm._v("CSS, JavaScript, and a browser that supports rendering SVGs."),
      ]),
    ])
  },
  function (_c, _vm) {
    return _c("td", [
      _c("span", { staticClass: "sr-only" }, [_vm._v("Not supported")]),
    ])
  },
  function (_c, _vm) {
    return _c("td", [
      _c("span", { staticClass: "sr-only" }, [_vm._v("Not supported")]),
    ])
  },
  function (_c, _vm) {
    return _c("td", [
      _c("span", { staticClass: "sr-only" }, [_vm._v("Not supported")]),
    ])
  },
  function (_c, _vm) {
    return _c("td", [
      _c("span", { staticClass: "sr-only" }, [_vm._v("Not supported")]),
    ])
  },
  function (_c, _vm) {
    return _c("td", [
      _c("span", { staticClass: "sr-only" }, [_vm._v("Not supported")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }